import { render } from "./BaseMenu.vue?vue&type=template&id=da30c4aa&scoped=true"
import script from "./BaseMenu.vue?vue&type=script&lang=js"
export * from "./BaseMenu.vue?vue&type=script&lang=js"

import "./BaseMenu.vue?vue&type=style&index=0&id=da30c4aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da30c4aa"]])

export default __exports__